import { DebugPortalContextProvider } from '#features/DebugSettings/DebugPortal'
import '#styles/themes'
import { css } from '@linaria/core'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { RouterProvider } from 'react-router-dom'
import { style } from '#styles/index'
import { router } from './app/routes/router'

const appClass = css`
  @media screen {
    background: ${style.theme.backgroundSurfacePrimaryStrong};
    margin: auto;
    width: 100%;
  }
`

export const App: FC = () => {
  return (
    <DebugPortalContextProvider>
      <div className={appClass}>
        <RouterProvider router={router} />
      </div>
    </DebugPortalContextProvider>
  )
}

export const AppFailure: FC = () => {
  const { t } = useTranslation()

  return <div>{t('app.startup-error', 'Failed loading MAN Intelligent Configurator!')}</div>
}
